import { gql, useQuery } from "@apollo/client";
import { getFetchPolicyOptions } from "api/utils";
import { ContactOverviewQuery } from "../types";

export const EXTENDED_CONTACT_QUERY = gql`
  query GetExtendedContactDetails($contactId: Long) {
    contact(id: $contactId) {
      id
      contactId
      name
      representatives {
        id
        contactId
        name
      }
      addresses {
        id
        address1
        address2
        zipCode
        city
        phone1
        email
      }
      juridical {
        id
        code
        name
      }
      taxCountry {
        id
        code
        name
      }
      nationality {
        id
        code
        name
      }
    }
  }
`;

export const useGetExtendedContactDetails = (
  contactId: number | string | undefined
) => {
  const { loading, error, data, refetch } = useQuery<ContactOverviewQuery>(
    EXTENDED_CONTACT_QUERY,
    {
      variables: { contactId },
      skip: !contactId,
      ...getFetchPolicyOptions(`useGetExtendedContactDetails.${contactId}`),
      notifyOnNetworkStatusChange: true,
    }
  );

  return {
    loading: loading,
    error: error,
    data: data && data,
    refetch,
  };
};
